<template>
  <div class="filter-bar critical-component-clear">
    <div class="filter-bar__container">
      <splide
        class="filter-bar__carousel"
        :has-track="false"
        :options="localConfig"
        :extensions="extensions"
      >
        <splide-track>
          <splide-slide
            v-for="(highlight, index) of highlights"
            :key="`filter-highlight-${index}`"
            class="filter-bar__highlight"
          >
            <icon-shipping />
            <p
              class="filter-bar__text text-heading-xs text-heading-s-desktop"
              v-text="highlight"
            />
          </splide-slide>
        </splide-track>
      </splide>
    </div>
  </div>
</template>

<script>

/**
 * Vue: Filter bar (filter-bar)
 * -----------------------------------------------------------------------------
 * Fixed bar with the collection filter and additional messages.
 *
 * @param {String} liquid.sectionId - Section's Liquid ID.
 *
 */

import IconShipping from '~icons/general/shipping.svg'
import { values as breakpoints } from '~/config/breakpoints'
import { Splide, SplideSlide, SplideTrack } from '@splidejs/vue-splide'
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll'
import { mapGetters } from 'vuex'

export default {
  name: 'FilterBar',

  components: {
    IconShipping,
    Splide,
    SplideSlide,
    SplideTrack,
  },

  props: {
    highlights: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {

    }
  },

  computed: {

    /**
     * Map Vuex getters.
     */
    ...mapGetters({
      getFilters: 'search/getFilters',
    }),

    productCount() {
      const filter = 'test'
      return filter
    },
  },

  beforeMount() {
    this.localConfig = {
      pagination: false,
      arrows: false,
      drag: 'free',
      autoScroll: {
        speed: 0.3,
      },
      focus: 'center',
      type: 'loop',
      mediaQuery: 'min',
      gap: '2.5rem',
      autoWidth: true,
      breakpoints: {
        [breakpoints.l]: {
          destroy: true,
        },
      },
    }

    this.extensions = {
      AutoScroll,
    }
  },

  methods: {
    // Not empty
  },
}
</script>

<style lang="scss">
@import './filter-bar';
</style>
